import { logTriggerExecute } from '../../features/triggers/trigger-analytics-actions.js';
import { triggerReducer as triggers } from '../../features/triggers/triggers-slice.js';
import { arrayEqual } from '../../utils/compare-utils.js';
import { loadReducerError } from '../../utils/errors.js';
import { buildController, } from '../controller/headless-controller.js';
/**
 * Creates a `ExecuteTrigger` controller instance. An execute trigger is configured in the Administration console,
 * and used to execute a function in the browser when a certain condition is met.
 *
 *
 * @param engine - The headless engine.
 * @returns A `RedirectionTrigger` controller instance.
 *
 * @group Controllers
 * @category ExecuteTrigger
 * */
export function buildExecuteTrigger(engine) {
    if (!loadExecuteTriggerReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    const getState = () => engine.state;
    let previousExecutions = getState().triggers.executions;
    return {
        ...controller,
        subscribe(listener) {
            const strictListener = () => {
                const hasChanged = !arrayEqual(this.state.executions, previousExecutions, (first, second) => first.functionName === second.functionName &&
                    arrayEqual(first.params, second.params));
                previousExecutions = this.state.executions;
                if (hasChanged && this.state.executions.length) {
                    listener();
                    dispatch(logTriggerExecute());
                }
            };
            strictListener();
            return engine.subscribe(strictListener);
        },
        get state() {
            return {
                executions: getState().triggers.executions,
            };
        },
    };
}
function loadExecuteTriggerReducers(engine) {
    engine.addReducers({ triggers });
    return true;
}
